import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(isSameOrBefore);
dayjs.extend(advancedFormat);

export default dayjs;
